import { axios } from '../../../../lib'
import { AuthUser } from '../types'

export const getUser = (): Promise<AuthUser> => {
  return axios.get('/authentication/me')
}
